import {mapFields} from 'vuex-map-fields';
import {mapActions, mapGetters} from 'vuex';
import {ENTRYPOINT} from '@/config/entrypoint';
import utilFetch from "@/utils/fetch";
import NotificationMixin from './NotificationMixin';

const entryPoint = ENTRYPOINT + (ENTRYPOINT.endsWith('/') ? '' : '/');

export default {
  data() {
    return {
      loadingMailAttachments: [],
    };
  },
  mixins: [NotificationMixin],
  computed: {
    ...mapFields('mailAttachment', {
      mailAttachment: 'current',
      uploadedMailAttachment: 'created',
      mailAttachmentIds: "allIds",
      mailAttachmentIdsCached: "cacheAllIds",
    }),
    ...mapGetters("mailAttachment", {
      findMailAttachment: "find",
    }),
    mailAttachmentUrl() {
      return entryPoint + this.mailAttachment.contentUrl;
    },
    mailAttachmentEntryPoint() {
      return entryPoint;
    }
  },
  methods: {
    ...mapActions('mailAttachment', {
      upload: 'createFormData',
      retrieveMailAttachment: 'load',
      deleteMailAttachment: 'del',
    }),
    uploadMailAttachment(mailAttachment, seminarEmailIri) {
      var formData = new FormData();
      formData.append('name', mailAttachment.name);
      formData.append('file', mailAttachment, mailAttachment.name);
      formData.append('seminarEmail', seminarEmailIri);
      return this.upload(formData);
    },
    downloadMailAttachment(contentUrl, fileName, notify = false) {
      utilFetch(contentUrl, {
        method: 'GET'
      }).then(response => response.blob())
        .then(blob => {
            const data = window.URL.createObjectURL(blob)
            let a = document.createElement("a");
            a.href = data;
            a.download = fileName;
            a.click();
            setTimeout(function () {
              window.URL.revokeObjectURL(data);
            }, 100);
          },
          error => {
            notify === true ? this.showError(error) : console.log("error!: " + error);
          }
        );
    },
    resolveMailAttachment(itemId) {
      if (!this.isMailAttachmentLoaded(itemId) && !this.loadingMailAttachments.includes(itemId)) {
        this.loadingMailAttachments.push(itemId);
        this.retrieveMailAttachment(decodeURIComponent(itemId));
      }
      return this.findMailAttachment(itemId);
    },
    resolveMailAttachments(itemIds) {
      if (typeof itemIds === "undefined") {
        return [];
      }
      return itemIds.map((itemId) => {
        return this.resolveMailAttachment(itemId['id']);
      }).filter(e => e);
    },
    isMailAttachmentLoaded(itemId) {
      return this.mailAttachmentIdsCached.includes(itemId);
    },
    getAndDownloadMailAttachment(item) {
      const poll = resolve => {
        let mailAttachment = null
        if(typeof item !== 'string' && item.contentUrl){
          mailAttachment = item;
        }else{
          if (this.isMailAttachmentLoaded((item))) {
            mailAttachment = this.resolveMailAttachment(item);
          } else {
            this.resolveMailAttachment(item);
            setTimeout(() => poll(resolve), 400);
          }
        }
        if(mailAttachment !== null){
            this.downloadMailAttachment(ENTRYPOINT + '/mail-attachment/' + mailAttachment['filePath'], mailAttachment.name);
            resolve();
        }
      }
      return new Promise(poll);
    },
    getMailAttachmentItem(itemId, type) {
      if (itemId !== null) {
        let item = this.resolveMailAttachment(itemId);
        if (item) {
          return item[type];
        }
      }
      return '';
    },
    getAndDownloadConfirmMailAttachment(itemId) {
      const poll = resolve => {
        if (this.isMailAttachmentLoaded((itemId))) {
          this.resolveMailAttachment(itemId);
          resolve();
        } else {
          this.resolveMailAttachment(itemId);
          setTimeout(() => poll(resolve), 400);
        }
      }
      return new Promise(poll);
    },
  }
};
